
import {Enum} from "./Enum.js";


export const CameraMode = {
	ORTHOGRAPHIC: 0,
	PERSPECTIVE: 1,
	VR: 2,
};

export const ClipTask = {
	NONE: 0,
	HIGHLIGHT: 1,
	SHOW_INSIDE: 2,
	SHOW_OUTSIDE: 3
};

export const ClipMethod = {
	INSIDE_ANY: 0,
	INSIDE_ALL: 1
};

export const ElevationGradientRepeat = {
	CLAMP: 0,
	REPEAT: 1,
	MIRRORED_REPEAT: 2,
};

export const MOUSE = {
	LEFT: 0b0001,
	RIGHT: 0b0010,
	MIDDLE: 0b0100
};

export const PointSizeType = {
	FIXED: 0,
	ATTENUATED: 1,
	ADAPTIVE: 2
};

export const PointShape = {
	SQUARE: 0,
	CIRCLE: 1,
	PARABOLOID: 2
};

export const TreeType = {
	OCTREE:	0,
	KDTREE:	1
};

export const LengthUnits = {
	METER: {code: 'm', unitspermeter: 1/1},
	CENTIMETER: {code: 'cm', unitspermeter: 1/0.01},
	MILLIMETER: {code: 'mm', unitspermeter: 1/0.001},
	MICROMETER: {code: 'um', unitspermeter: 1/0.000001},
	KILOMETER: {code: 'km', unitspermeter: 1/1000},
	FEET: {code: 'ft', unitspermeter: 1/0.3048},
	USSURVEYFOOT: {code: 'usft', unitspermeter: 1/0.3048006096012192},
	INCH: {code: 'in', unitspermeter: 1/0.0254},
	MIL: {code: 'mil', unitspermeter: 1/0.0000254},
	MICROINCH: {code: 'uin', unitspermeter: 1/0.0000000254},
	YARD: {code: 'yd', unitspermeter: 1/0.9144},
	MILE: {code: 'mi', unitspermeter: 1/1609.344},
};